module.exports = __webpack_public_path__ + "img/Mark.c3dda482.jpg";